import gql from 'graphql-tag';

export const DeleteParticipantBehaviour = gql`
  mutation DeleteParticipantBehaviour($organizationId: ID!, $participantId: ID!, $participantBehaviourId: ID!) {
    deleteParticipantBehaviour(
      organizationId: $organizationId
      participantId: $participantId
      participantBehaviourId: $participantBehaviourId
    ) {
      id
    }
  }
`;
